import React from "react";
import { MessageCircle } from "lucide-react";
import { api } from "../lib/api";
import { WHATSAPP_ENABLED } from "../lib/whatsapp";

export default function FloatingWhatsApp({ phone }) {
  if (!WHATSAPP_ENABLED || !phone) return null;
  const num = phone.replace(/\D/g, "");
  const onClick = () => { try { api.post("/track/whatsapp", {}); } catch (_e) { /* noop */ } };
  return (
    <a href={`https://wa.me/${num}`} target="_blank" rel="noreferrer" onClick={onClick}
      className="fixed bottom-6 right-6 z-40 group" data-testid="floating-whatsapp">
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-emerald-400/50 blur-xl animate-pulse" />
        <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center border border-white/30 shadow-[0_10px_40px_rgba(16,185,129,0.5)]">
          <MessageCircle className="w-6 h-6 text-white" />
        </div>
      </div>
    </a>
  );
}
